<template>
  <!-- A palette's search row: a borderless search box between a leading slot (a search icon by default,
       or a Back button and a context chip) and a trailing slot (a shortcut hint). -->
  <div class="flex items-center gap-3 border-b border-surface-200 px-4">
    <slot name="leading">
      <MaterialIcon
        class="shrink-0 text-surface-400"
        ligature="search"
        size="1.25rem"
      />
    </slot>
    <TwnSearchInput
      ref="search-input"
      v-model="query"
      :placeholder="placeholder"
      :pt="inputPt"
      class="flex-1"
      @enter="emit('enter', $event)"
    >
      <!-- Suppress the built-in pre icon; the leading slot renders its own as a flex sibling -->
      <template #pre><span class="hidden" /></template>
    </TwnSearchInput>
    <slot name="trailing" />
  </div>
</template>

<script lang="ts" setup>
import { computed, useTemplateRef } from 'vue'

import type {
  TwnPaletteSearchEmits,
  TwnPaletteSearchProps
} from '@/components/molecules/palette/twn-palette-search/TwnPaletteSearch.types'

import MaterialIcon from '@/components/atoms/icons/material-icon/MaterialIcon.vue'
import TwnSearchInput from '@/components/atoms/prime/input-search/twn-search-input/TwnSearchInput.vue'

const props = defineProps<TwnPaletteSearchProps>()

const emit = defineEmits<TwnPaletteSearchEmits>()

const query = defineModel<string | undefined>({ default: undefined })

const searchInput = useTemplateRef<InstanceType<typeof TwnSearchInput>>('search-input')

const INPUT_CLASS =
  '!border-0 !bg-transparent !shadow-none !text-lg !px-0 !py-3.5 focus:!ring-0 focus:!shadow-none focus-visible:!outline-none'

const inputPt = computed(() => ({ root: { class: INPUT_CLASS, ...props.inputAttrs } }))

defineExpose({
  focus: () => searchInput.value?.focus()
})
</script>
